import React from 'react';
import { Auth } from 'aws-amplify';

class SignOut extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
    };
  }

  componentDidMount() {
    Auth
      .signOut()
      .catch((err) => {
        console.error('SignOut Error', err); // eslint-disable-line no-console
        this.setState({ error: err });
      });
  }

  render() {
    const { error } = this.state;
    if (error) {
      return <div>There was a problem signing you out. Please try again</div>;
    }
    return <div />;
  }
}

export default SignOut;
